import {
  getComparisonSummary,
  buildVarianceHeadline,
  buildScopeItems,
} from '../../shared/baselineComparisonDisplay.js';
import { formatDateDDMonYYYY } from '../../utils/dates.js';

/**
 * BASELINE-SUB4: compact comparison strip near the verdict/score area — the
 * dashboard twin of the PDF cover callout. Renders only when the payload carries
 * comparison metadata. All figures come from the shared getComparisonSummary,
 * and the headline + scope row from the shared builders the PDF cover adapter
 * also calls (canonical fields; no recompute — Rule 12), so the banner, the
 * PDF cover, and the per-check bodies cannot drift.
 */
export function ComparisonBanner({ analysis }) {
  const cmp = getComparisonSummary(analysis);
  if (!cmp) return null;

  // Amber ONLY when delayed beyond threshold; otherwise navy. Not a severity.
  const headline = buildVarianceHeadline(cmp);
  const scopeItems = buildScopeItems(cmp);

  return (
    <div className="comparison-banner" role="note" aria-label="Baseline comparison">
      <div className="comparison-banner-head">
        <span className="comparison-banner-tag">BASELINE COMPARISON</span>
        <span className="comparison-banner-provenance">
          Compared against <strong>{cmp.baselineFilename || '—'}</strong>
          {' · '}Baseline data date {formatDateDDMonYYYY(cmp.baselineDataDate)}
        </span>
      </div>
      <div className={`comparison-banner-headline${headline.alert ? ' is-alert' : ''}`}>{headline.text}</div>
      <div className="comparison-banner-scope">
        {scopeItems.map((s) => (
          <span key={s.label}><strong>{s.value}</strong> {s.label}</span>
        ))}
      </div>
      <div className="comparison-banner-note">
        For information — the baseline comparison does not affect the health score.
      </div>
    </div>
  );
}
